// Unpublished marketing surfaces show on preview/local only until the owner approves them.
export const SHOW_TOURNAMENT_MARKETING = /(\.preview\.emergentagent\.com|localhost|127\.0\.0\.1)$/.test(window.location.hostname);
